export default [
  {
    path: '/',
    component: () => import('../view/home.vue')
  },
  {
    path: '/app/:visitId',
    component: () => import('../view/app.vue')
  },
  {
    path: '/file',
    component: () => import('../view/upload.vue')
  },
  {
    path: '/404',
    component: () => import('../view/notfound.vue')
  }
]
